import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "Badge"
}
const _hoisted_2 = {
  key: 1,
  class: "Badge"
}
const _hoisted_3 = {
  key: 1,
  class: "RefineContentOptionsList"
}
const _hoisted_4 = {
  key: 0,
  class: "LocationSwitcher"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LocationSkeletonLoader = _resolveComponent("LocationSkeletonLoader")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["LocationFilterWrapper", { 'is-collapsed': _ctx.collapsed }])
  }, [
    _createElementVNode("header", {
      class: "RefineSectionHeading",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleFilter()))
    }, [
      _cache[4] || (_cache[4] = _createElementVNode("i", { class: "lnr-map-marker FilterIcon" }, null, -1 /* CACHED */)),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "Title" }, "Location", -1 /* CACHED */)),
      (_ctx.countryFilterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.countryFilterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      (_ctx.continentFilterHintCount > 0)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.continentFilterHintCount), 1 /* TEXT */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("i", {
        class: _normalizeClass(["ToggleIcon", [_ctx.collapsed ? 'lnr-chevron-down' : 'lnr-chevron-up']])
      }, null, 2 /* CLASS */)
    ]),
    (_ctx.isBusy)
      ? (_openBlock(), _createBlock(_component_LocationSkeletonLoader, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.includeContinents)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleCountryFilter && _ctx.toggleCountryFilter(...args))),
                  class: _normalizeClass(["CountrySwitcher", { 'is-active': _ctx.activeLocationFilterType === _ctx.LocationFilterType.COUNTRY }])
                }, " Country ", 2 /* CLASS */),
                _createElementVNode("i", {
                  class: "lnr-arrows-switch SwitcherIcon",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.switchTabs && _ctx.switchTabs(...args)))
                }),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.toggleContinentFilter && _ctx.toggleContinentFilter(...args))),
                  class: _normalizeClass(["ContinentSwitcher", { 'is-active': _ctx.activeLocationFilterType === _ctx.LocationFilterType.CONTINENT }])
                }, " Continent ", 2 /* CLASS */)
              ]))
            : _createCommentVNode("v-if", true),
          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeLocationFilterType)))
        ]))
  ], 2 /* CLASS */))
}